var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pagamento',{directives:[{name:"show",rawName:"v-show",value:(_vm.mostrarPagamento),expression:"mostrarPagamento"}],attrs:{"pagamento":_vm.pagamento,"pagamentosServicos":_vm.obterPagamentosServicos()},on:{"obterPagamentoAtualizado":function($event){return _vm.obterPagamentoAtualizado()}}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }